import { render, staticRenderFns } from "./Urls.vue?vue&type=template&id=0ed190d0&scoped=true"
import script from "./Urls.vue?vue&type=script&lang=js"
export * from "./Urls.vue?vue&type=script&lang=js"
import style0 from "./Urls.vue?vue&type=style&index=0&id=0ed190d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed190d0",
  null
  
)

export default component.exports